/**
 * Wipe every JS-readable cookie on every plausible (path, domain) tuple plus
 * localStorage / sessionStorage. Recovery path for users stranded by a
 * CloudFront 431 due to accumulated cookies (Cognito Hosted UI, oauth state,
 * XSRF tokens). HttpOnly cookies survive — they're invisible to JS — but the
 * accumulating contributors aren't HttpOnly, so this brings the request
 * header back under CloudFront's cap in practice.
 */
export function clearBrowserAuthState(): void {
  const host = window.location.hostname;
  const parts = host.split('.');
  const domains = [
    host,
    ...parts
      .map((_, i) => '.' + parts.slice(i).join('.'))
      .filter((d) => d.includes('.') && d !== '.'),
    '',
  ];
  const paths = ['/', '/api', '/api/v1', '/oauth', '/signin'];

  for (const cookie of document.cookie.split(';')) {
    const name = cookie.split('=')[0]?.trim();
    if (!name) continue;
    for (const domain of domains) {
      for (const path of paths) {
        document.cookie =
          `${name}=; Max-Age=0; path=${path}` +
          (domain ? `; domain=${domain}` : '');
      }
    }
  }

  try {
    localStorage.clear();
  } catch {
    // private mode / disabled storage
  }
  try {
    sessionStorage.clear();
  } catch {
    // private mode / disabled storage
  }
}
